import React from 'react'
import ReactDOM from 'react-dom';
import axios from 'axios';
import { PulseLoader } from 'react-spinners';
import qs from 'qs';
import ReactPaginate from 'react-paginate';
import URLSearchParams from "url-search-params";

import Card from 'components/marketplace/card';
import CardListHeader from 'components/marketplace/cardListHeader';
import Colorful from "mixins/colorful"
import SearchFilter from 'components/marketplace/searchFilter';
import SearchFilterModal from 'components/marketplace/searchFilterModal';

class MarketPlace extends React.Component {
  constructor(props) {
    super(props);

    let params = qs.parse(location.search.slice(1))
    this.state = {
      showModal: false,
      selectedTender: params.by_tender || [],
      selectedBodyTypes: params.by_body_type || [],
      selectedMakes: params.by_make || [],
      selectedModel: params.by_model || [],
      selectedLocation: params.by_location || [],
      selectedTransmission: params.by_transmission || [],
      selectedEngine: params.by_engine || [],
      selectedFuel: params.by_fuel || [],
      selectedExteriorColor: params.by_exterior_color || [],
      selectedCondition: params.by_condition || [],
      selectedProduct: params.by_product || [],
      selectedRoadworthy: params.by_roadworthy || '',
      yearLeftHandleValue: params.by_year ? parseInt(params.by_year.yearLeftHandleValue) || null : null,
      yearRightHandleValue: params.by_year ? parseInt(params.by_year.yearRightHandleValue)|| null : null,
      vehicleData: {},
      loadingVehicles: true,
      mileageLeftHandleValue: params.by_mileage ? parseInt(params.by_mileage.mileageLeftHandleValue) || null : null,
      mileageRightHandleValue: params.by_mileage ? parseInt(params.by_mileage.mileageRightHandleValue) || null : null,
      totalNumberOfVehicle: '',
      sortDirection: params.by_order ? params.by_order.direction || 'desc' : 'desc',
      sortOption: params.by_order ? params.by_order.column || 'mileage' : 'mileage',
      page: parseInt(params.page) || 1,
      totalPages: 1,
      filterData: {},
      filterOptions: {},
      tenders: {},
      totalVehiclesForSale: 0
    }

    Colorful.call(this);
    this.handleProductType = this.handleProductType.bind(this);
    this.handleRoadworthy = this.handleRoadworthy.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.fetchVehicleData = this.fetchVehicleData.bind(this);
    this.updateMileageValue = this.updateMileageValue.bind(this);
    this.updateYearValue = this.updateYearValue.bind(this);
    this.onSliderDragEnd = this.onSliderDragEnd.bind(this);
    this.handleSortOption = this.handleSortOption.bind(this);
    this.handleSortDirection = this.handleSortDirection.bind(this);
  }

  componentWillMount() {
    this.fetchVehicleData();
  }

  openModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  updateYearValue(sliderState) {
    const yearLeftHandleValue = sliderState.values[0]
    const yearRightHandleValue = sliderState.values[1]

    this.setState({
      yearLeftHandleValue: sliderState.values[0],
      yearRightHandleValue: sliderState.values[1],
      page: 1
    });

  }

  updateMileageValue(sliderState) {
    const mileageLeftHandleValue = sliderState.values[0]
    const mileageRightHandleValue = sliderState.values[1]

    this.setState({
      mileageLeftHandleValue: sliderState.values[0],
      mileageRightHandleValue: sliderState.values[1],
      page: 1
    });
  }

  handleSortDirection(event) {
    const direction = event.target.value
    this.setState({ sortDirection: direction, page: 1 }, this.fetchVehicleData.bind(this))
  }

  handleSortOption(event) {
    const option = event.target.value
    this.setState({ sortOption: option, page: 1 }, this.fetchVehicleData.bind(this))
  }

  onSliderDragEnd() {
    const { yearLeftHandleValue, yearRightHandleValue, mileageLeftHandleValue, mileageRightHandleValue } = this.state
    if (isNaN(mileageLeftHandleValue) || isNaN(mileageRightHandleValue)) {
      return false
    } else if (isNaN(yearLeftHandleValue) || isNaN(yearRightHandleValue)) {
      return false
    } else {
      this.fetchVehicleData();
    }
  }

  handleCheckbox(event) {
    const target = event.target;
    const option = target.value;
    const value = target.checked;
    const name = target.name;
    let selectedOption = this.state[option];

    if (value) {
      selectedOption.push(name)
    } else {
      selectedOption = selectedOption.filter(option => option !== name)
    }

    this.setState({
      filterOptions: {},
      loadingVehicles: true,
      page: 1,
      [option]: selectedOption
    }, this.fetchVehicleData.bind(this))
  }

  handleRoadworthy(event) {
    let selectedRoadworthy = event.target.innerText;
    if (this.state.selectedRoadworthy === selectedRoadworthy) { selectedRoadworthy = ''; }

    this.setState({
      filterOptions: {},
      loadingVehicles: true,
      page: 1,
      selectedRoadworthy
    }, this.fetchVehicleData.bind(this))
  }


  handleProductType(event) {
    let selectedProduct = event.target.value;

    this.setState({
      filterOptions: {},
      loadingVehicles: true,
      page: 1,
      selectedProduct
    }, this.fetchVehicleData.bind(this))
  }

  handlePageClick = (data) => {
    let page = data.selected;
    this.setState({page: page + 1}, this.fetchVehicleData.bind(this))

  }

  fetchVehicleData() {
    const {
      selectedTender,
      selectedCondition,
      selectedExteriorColor,
      selectedFuel,
      selectedEngine,
      selectedTransmission,
      selectedRoadworthy,
      selectedProduct,
      selectedLocation,
      yearLeftHandleValue,
      yearRightHandleValue,
      selectedMakes,
      selectedModel,
      selectedBodyTypes,
      mileageLeftHandleValue,
      mileageRightHandleValue,
      sortOption,
      sortDirection } = this.state

    let params = {
      by_tender: selectedTender,
      by_condition: selectedCondition,
      by_exterior_color: selectedExteriorColor,
      by_fuel: selectedFuel,
      by_engine: selectedEngine,
      by_transmission: selectedTransmission,
      by_roadworthy: selectedRoadworthy,
      by_product: selectedProduct,
      by_location: selectedLocation,
      by_make: selectedMakes,
      by_model: selectedModel,
      by_body_type: selectedBodyTypes,
      by_order: {
        column: sortOption,
        direction: sortDirection,
      },
      by_mileage: {
        mileageLeftHandleValue: mileageLeftHandleValue,
        mileageRightHandleValue: mileageRightHandleValue,
      },
      by_year: {
        yearLeftHandleValue: yearLeftHandleValue,
        yearRightHandleValue: yearRightHandleValue,
      },
      page: this.state.page,
    }
    let pageUrl = '?' + qs.stringify(params, { arrayFormat: 'brackets' })
    window.history.pushState('', '', pageUrl);

    axios({
      method:'get',
      url:'/marketplace.json',
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
      responseType:'json'
    })
    .then((response) => {
      if (this.state.mileageRightHandleValue == null && response.data.filter_options.max_mileage !== null) {
          this.setState({
          mileageLeftHandleValue: response.data.filter_options.min_mileage,
          mileageRightHandleValue: response.data.filter_options.max_mileage,
          yearLeftHandleValue: response.data.filter_options.min_year,
          yearRightHandleValue: response.data.filter_options.max_year
        })
      }

      if ((params.by_mileage.mileageLeftHandleValue != mileageLeftHandleValue) || (params.by_mileage.mileageRightHandleValue != mileageRightHandleValue)) {
          this.setState({
          mileageLeftHandleValue: params.by_mileage.mileageLeftHandleValue,
          mileageRightHandleValue: params.by_mileage.mileageRightHandleValue
        })
      }

      this.setState({
        tenders: response.data.tenders,
        vehicleData: response.data.vehicles,
        filterOptions: response.data.filter_options,
        filterData: response.data.filter_options.filter_data,
        loadingVehicles: false,
        totalNumberOfVehicle: response.data.vehicles.length,
        totalPages: response.data.filter_options.total_pages,
        totalVehiclesForSale: response.data.total_vehicle_counts
      })

      if (this.state.page > response.data.filter_options.total_pages)
      return null;
    }).catch((error) => {
      console.log(error)
    });
  }

  render() {
    const { selectedTender, tenders, yearLeftHandleValue, yearRightHandleValue, filterOptions, filterData, sortOption, sortDirection, mileageLeftHandleValue, mileageRightHandleValue, totalNumberOfVehicle, vehicleData, bodyTypeCoupe, bodyTypeDuabCab, bodyTypeHatchback, bodyTypeSedan, bodyTypeWagon, selectedBodyTypes, selectedMakes, selectedModel, selectedLocation, selectedTransmission, selectedEngine, selectedFuel, selectedExteriorColor, selectedCondition, selectedProduct, selectedRoadworthy } = this.state;
    let renderVehicleCard = null

    if (vehicleData.length > 0) {
      renderVehicleCard = vehicleData.map((vehicle) => {
        return <Card key={vehicle.id} vehicle={vehicle} />
      })
    }
    return (
      <section>
        <div className="filter-section visible-xs visible-sm text-center btn btn-white" onClick={this.openModal}>
          <span>Filter</span>
        </div>
        <SearchFilterModal showModal={this.state.showModal} closeModal={this.closeModal}>
          <SearchFilter
            tenders={tenders}
            filterOptions={filterOptions}
            filterData={filterData}
            bodyTypeCoupe={bodyTypeCoupe}
            bodyTypeDuabCab={bodyTypeDuabCab}
            bodyTypeHatchback={bodyTypeHatchback}
            bodyTypeSedan={bodyTypeSedan}
            bodyTypeWagon={bodyTypeWagon}
            mileageLeftHandleValue={mileageLeftHandleValue}
            mileageRightHandleValue={mileageRightHandleValue}
            yearLeftHandleValue={yearLeftHandleValue}
            yearRightHandleValue={yearRightHandleValue}
            updateMileageValue={this.updateMileageValue}
            updateYearValue={this.updateYearValue}
            onSliderDragEnd={this.onSliderDragEnd}
            handleProductType={this.handleProductType}
            handleRoadworthy={this.handleRoadworthy}
            handleCheckbox={this.handleCheckbox}
            selectedBodyTypes={selectedBodyTypes}
            selectedTender={selectedTender}
            selectedMakes={selectedMakes}
            selectedModel={selectedModel}
            selectedLocation={selectedLocation}
            selectedTransmission={selectedTransmission}
            selectedEngine={selectedEngine}
            selectedFuel={selectedFuel}
            selectedExteriorColor={selectedExteriorColor}
            selectedCondition={selectedCondition}
            selectedProduct={selectedProduct}
            selectedRoadworthy={selectedRoadworthy}
          />
        </SearchFilterModal>
        <div className="container">
          <div className="row">
            <div className="col-md-5 visible-md visible-lg">
              <div className="float-box">
                <div className="row">
                  <div className="col-sm-11">
                    <div className="text-content">
                      <SearchFilter
                        tenders={tenders}
                        filterData={filterData}
                        filterOptions={filterOptions}
                        bodyTypeCoupe={bodyTypeCoupe}
                        bodyTypeDuabCab={bodyTypeDuabCab}
                        bodyTypeHatchback={bodyTypeHatchback}
                        bodyTypeSedan={bodyTypeSedan}
                        bodyTypeWagon={bodyTypeWagon}
                        mileageLeftHandleValue={mileageLeftHandleValue}
                        mileageRightHandleValue={mileageRightHandleValue}
                        yearLeftHandleValue={yearLeftHandleValue}
                        yearRightHandleValue={yearRightHandleValue}
                        updateMileageValue={this.updateMileageValue}
                        updateYearValue={this.updateYearValue}
                        onSliderDragEnd={this.onSliderDragEnd}
                        handleProductType={this.handleProductType}
                        handleRoadworthy={this.handleRoadworthy}
                        handleCheckbox={this.handleCheckbox}
                        selectedBodyTypes={selectedBodyTypes}
                        selectedTender={selectedTender}
                        selectedMakes={selectedMakes}
                        selectedModel={selectedModel}
                        selectedLocation={selectedLocation}
                        selectedTransmission={selectedTransmission}
                        selectedEngine={selectedEngine}
                        selectedFuel={selectedFuel}
                        selectedExteriorColor={selectedExteriorColor}
                        selectedCondition={selectedCondition}
                        selectedProduct={selectedProduct}
                        selectedRoadworthy={selectedRoadworthy}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <CardListHeader
                total={this.state.totalVehiclesForSale}
                sortOption={sortOption}
                sortDirection={sortDirection}
                handleSort={this.handleSortOption}
                handleSortDirection={this.handleSortDirection}
              />
              {renderVehicleCard}
              <div className="text-center">
                <PulseLoader color={this.colors.red} size={30} loading={this.state.loadingVehicles} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-offset-5">
          <ReactPaginate previousLabel={"previous"}
             nextLabel={"next"}
             breakLabel={<a href="">...</a>}
             breakClassName={"break-me"}
             pageCount= {this.state.totalPages}
             initialPage={this.state.page - 1}
             disableInitialCallback={true}
             marginPagesDisplayed={2}
             pageRangeDisplayed={10}
             onPageChange={this.handlePageClick}
             containerClassName={"pagination"}
             subContainerClassName={"pages pagination"}
             activeClassName={"active"}
             forcePage={this.state.page - 1} />
        </div>
      </section>
    )
  }
};

export default MarketPlace;
